import React from 'react'
import { findDOMNode } from 'react-dom'



const PreventParentScroll = React.createClass({

    getScrollParent(currentNode) {
        let el = currentNode
        do {
            switch (getComputedStyle(el).overflowY) {
                case 'auto':
                case 'scroll':
                case 'overlay':
                    return el;
            }
        } while ((el = el.parentElement))
        return window
    },


    animationScroll(time) {
        var { node } = this
        if (Math.abs(this.TouchDelta) > 1) {
            this.scrollValue0 -= this.TouchDelta;
            this.intermediateScroll();
            this.TouchDelta *= 0.9;
            this.animationId = requestAnimationFrame(this.animationScroll);
        } else {
            this.scrollValue0 = Math.min(
                node.scrollHeight - node.offsetHeight,
                Math.max(0, this.scrollValue0)
            )
            this.scrollValue1 += (this.scrollValue0 - this.scrollValue1) * 0.3;
            this.scrollValue2 += (this.scrollValue1 - this.scrollValue2) * 0.3;
            node.scrollTop += Math.round((this.scrollValue2 - node.scrollTop) * 0.3);

            if (Math.abs(node.scrollTop - this.scrollValue2) >= 1)
                this.animationId = requestAnimationFrame(this.animationScroll);

        }


    },

    onMouseWheel(e) {
        this.scrollValue0 -= e.wheelDeltaY
        cancelAnimationFrame(this.animationId)
        this.animationId = requestAnimationFrame(this.animationScroll)
        e.preventDefault()
    },
    touchStart(e) {
        this.onTouch = true;
        this.touchHasMove = false;
        this.touchY = e.changedTouches[0].clientY;
        this.touchYBack = e.changedTouches[0].clientY;

    },
    intermediateScroll() {
        this.scrollValue0 = Math.min(
            this.node.scrollHeight - this.node.offsetHeight,
            Math.max(0, this.scrollValue0)
        )
        this.scrollValue1 = this.scrollValue0;
        this.scrollValue2 = this.scrollValue0;
        this.node.scrollTop = this.scrollValue2;

    },
    touchMove(e) {
        cancelAnimationFrame(this.animationId);
        this.TouchDelta = e.changedTouches[0].clientY - this.touchYBack;

        this.touchYBack = e.changedTouches[0].clientY;

        this.scrollValue0 -= this.TouchDelta;

        this.intermediateScroll();

        e.preventDefault();

    },
    touchEnd(e) {
        this.onTouch = false;

        if (Math.abs(e.changedTouches[0].clientY - this.touchY) > 5) {
            e.preventDefault();
        }

        if (Math.abs(this.TouchDelta) > 2) {
            this.animationId = requestAnimationFrame(this.animationScroll);
        } else {
            this.TouchDelta = 0;
        }
    },


    componentDidMount() {

        this.node = this.getScrollParent(findDOMNode(this));

        this.node.onmousewheel = this.onMouseWheel;

        this.scrollValue0 = 0;
        this.scrollValue1 = 0;
        this.scrollValue2 = 0;

        // window.addEventListener('touchstart', this.touchStart);
        // window.addEventListener('touchend', this.touchEnd);
        // window.addEventListener('touchmove', this.touchMove);


    },

    componentWillUnmount() {
        cancelAnimationFrame(this.animationId);
        // window.removeEventListener('touchstart', this.touchStart);
        // window.removeEventListener('touchend', this.touchEnd);
        // window.removeEventListener('touchmove', this.touchMove);
    },

    render() {
        return <div style = { { display: 'none' } }/>
    }

})

export default PreventParentScroll;


// WEBPACK FOOTER //
// ./js/lib/scroll/prevent-scroll.js